<vsf-collection-breadcrumbs [breadcrumbs]="breadcrumbs$ | async" class="bg-surface"></vsf-collection-breadcrumbs>
<!-- @let collections = collections$ | async; -->
<div class="page w-full h-full flex flex-col lg:flex-row bg-surface">
    @if (!(isMobile$ | async) && (collections$ | async); as collections) {
        <vsf-custom-navigator [collections]="collections" class="sidebar w-96 bg-white"></vsf-custom-navigator>
    }
    <div class="page-content min-w-0 max-w-full overflow-hidden w-full lg:flex-1 flex-col pr-4 lg:pr-8 pl-4 lg:pl-12">
        <vsf-custom-sales-banner></vsf-custom-sales-banner>
        <vsf-custom-product-slider-wraper [type]="'trending'" [productId]="null"></vsf-custom-product-slider-wraper>
        <vsf-custom-home-categories></vsf-custom-home-categories>
        <vsf-custom-product-slider-wraper [type]="'recentlyViewed'" [productId]="null"></vsf-custom-product-slider-wraper>
    </div>
</div>  